/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Role } from './role';

export interface UserFullDto { 
    id?: number;
    title?: UserFullDto.TitleEnum;
    salutation?: UserFullDto.SalutationEnum;
    firstName?: string;
    lastName?: string;
    mail?: string;
    birthdate?: Date;
    phoneNumber?: string;
    street?: string;
    houseNumber?: string;
    zipCode?: string;
    city?: string;
    branch?: UserFullDto.BranchEnum;
    country?: UserFullDto.CountryEnum;
    profileImage?: string;
    isActivated?: boolean;
    numberOfPersonalProjects?: number;
    roleInOrganisations?: { [key: string]: Role; };
    roleInProjects?: { [key: string]: Role; };
    chatIdentity?: string;
    isUsing2FA?: boolean;
    isUsing2FAViaMail?: boolean;
}
export namespace UserFullDto {
    export type TitleEnum = 'PROF' | 'PROF_DR' | 'DR' | 'NONE';
    export const TitleEnum = {
        PROF: 'PROF' as TitleEnum,
        PROFDR: 'PROF_DR' as TitleEnum,
        DR: 'DR' as TitleEnum,
        NONE: 'NONE' as TitleEnum
    };
    export type SalutationEnum = 'HERR' | 'FRAU' | 'NONE';
    export const SalutationEnum = {
        HERR: 'HERR' as SalutationEnum,
        FRAU: 'FRAU' as SalutationEnum,
        NONE: 'NONE' as SalutationEnum
    };
    export type BranchEnum = 'BAUHERR' | 'PROJEKTENTWICKLER' | 'PROJEKTSTEUERER' | 'VERANTWORTLICHER_PLANER' | 'FACHPLANER' | 'AUSFÜHRENDES_BAUUNTERNEHMEN' | 'NUTZER' | 'BAUGENEHMIGUNGSBEHÖRDE';
    export const BranchEnum = {
        BAUHERR: 'BAUHERR' as BranchEnum,
        PROJEKTENTWICKLER: 'PROJEKTENTWICKLER' as BranchEnum,
        PROJEKTSTEUERER: 'PROJEKTSTEUERER' as BranchEnum,
        VERANTWORTLICHERPLANER: 'VERANTWORTLICHER_PLANER' as BranchEnum,
        FACHPLANER: 'FACHPLANER' as BranchEnum,
        AUSFHRENDESBAUUNTERNEHMEN: 'AUSFÜHRENDES_BAUUNTERNEHMEN' as BranchEnum,
        NUTZER: 'NUTZER' as BranchEnum,
        BAUGENEHMIGUNGSBEHRDE: 'BAUGENEHMIGUNGSBEHÖRDE' as BranchEnum
    };
    export type CountryEnum = 'AND' | 'ARE' | 'AFG' | 'ATG' | 'AIA' | 'ALB' | 'ARM' | 'AGO' | 'ATA' | 'ARG' | 'ASM' | 'AUT' | 'AUS' | 'ABW' | 'ALA' | 'AZE' | 'BIH' | 'BRB' | 'BGD' | 'BEL' | 'BFA' | 'BGR' | 'BHR' | 'BDI' | 'BEN' | 'BLM' | 'BMU' | 'BRN' | 'BOL' | 'BES' | 'BRA' | 'BHS' | 'BTN' | 'BVT' | 'BWA' | 'BLR' | 'BLZ' | 'CAN' | 'CCK' | 'COD' | 'CAF' | 'COG' | 'CHE' | 'CIV' | 'COK' | 'CHL' | 'CMR' | 'CHN' | 'COL' | 'CRI' | 'CUB' | 'CPV' | 'CUW' | 'CXR' | 'CYP' | 'CZE' | 'DEU' | 'DJI' | 'DNK' | 'DMA' | 'DOM' | 'DZA' | 'ECU' | 'EST' | 'EGY' | 'ESH' | 'ERI' | 'ESP' | 'ETH' | 'FIN' | 'FJI' | 'FLK' | 'FSM' | 'FRO' | 'FRA' | 'GAB' | 'GBR' | 'GRD' | 'GEO' | 'GUF' | 'GGY' | 'GHA' | 'GIB' | 'GRL' | 'GMB' | 'GIN' | 'GLP' | 'GNQ' | 'GRC' | 'SGS' | 'GTM' | 'GUM' | 'GNB' | 'GUY' | 'HKG' | 'HMD' | 'HND' | 'HRV' | 'HTI' | 'HUN' | 'IDN' | 'IRL' | 'ISR' | 'IMN' | 'IND' | 'IOT' | 'IRQ' | 'IRN' | 'ISL' | 'ITA' | 'JEY' | 'JAM' | 'JOR' | 'JPN' | 'KEN' | 'KGZ' | 'KHM' | 'KIR' | 'COM' | 'KNA' | 'PRK' | 'KOR' | 'KWT' | 'CYM' | 'KAZ' | 'LAO' | 'LBN' | 'LCA' | 'LIE' | 'LKA' | 'LBR' | 'LSO' | 'LTU' | 'LUX' | 'LVA' | 'LBY' | 'MAR' | 'MCO' | 'MDA' | 'MNE' | 'MAF' | 'MDG' | 'MHL' | 'MKD' | 'MLI' | 'MMR' | 'MNG' | 'MAC' | 'MNP' | 'MTQ' | 'MRT' | 'MSR' | 'MLT' | 'MUS' | 'MDV' | 'MWI' | 'MEX' | 'MYS' | 'MOZ' | 'NAM' | 'NCL' | 'NER' | 'NFK' | 'NGA' | 'NIC' | 'NLD' | 'NOR' | 'NPL' | 'NRU' | 'NIU' | 'NZL' | 'OMN' | 'PAN' | 'PER' | 'PYF' | 'PNG' | 'PHL' | 'PAK' | 'POL' | 'SPM' | 'PCN' | 'PRI' | 'PSE' | 'PRT' | 'PLW' | 'PRY' | 'QAT' | 'REU' | 'ROU' | 'SRB' | 'RUS' | 'RWA' | 'SAU' | 'SLB' | 'SYC' | 'SDN' | 'SWE' | 'SGP' | 'SHN' | 'SVN' | 'SJM' | 'SVK' | 'SLE' | 'SMR' | 'SEN' | 'SOM' | 'SUR' | 'SSD' | 'STP' | 'SLV' | 'SXM' | 'SYR' | 'SWZ' | 'TCA' | 'TCD' | 'ATF' | 'TGO' | 'THA' | 'TJK' | 'TKL' | 'TLS' | 'TKM' | 'TUN' | 'TON' | 'TUR' | 'TTO' | 'TUV' | 'TWN' | 'TZA' | 'UKR' | 'UGA' | 'UMI' | 'USA' | 'URY' | 'UZB' | 'VAT' | 'VCT' | 'VEN' | 'VGB' | 'VIR' | 'VNM' | 'VUT' | 'WLF' | 'WSM' | 'YEM' | 'MYT' | 'ZAF' | 'ZMB' | 'ZWE';
    export const CountryEnum = {
        AND: 'AND' as CountryEnum,
        ARE: 'ARE' as CountryEnum,
        AFG: 'AFG' as CountryEnum,
        ATG: 'ATG' as CountryEnum,
        AIA: 'AIA' as CountryEnum,
        ALB: 'ALB' as CountryEnum,
        ARM: 'ARM' as CountryEnum,
        AGO: 'AGO' as CountryEnum,
        ATA: 'ATA' as CountryEnum,
        ARG: 'ARG' as CountryEnum,
        ASM: 'ASM' as CountryEnum,
        AUT: 'AUT' as CountryEnum,
        AUS: 'AUS' as CountryEnum,
        ABW: 'ABW' as CountryEnum,
        ALA: 'ALA' as CountryEnum,
        AZE: 'AZE' as CountryEnum,
        BIH: 'BIH' as CountryEnum,
        BRB: 'BRB' as CountryEnum,
        BGD: 'BGD' as CountryEnum,
        BEL: 'BEL' as CountryEnum,
        BFA: 'BFA' as CountryEnum,
        BGR: 'BGR' as CountryEnum,
        BHR: 'BHR' as CountryEnum,
        BDI: 'BDI' as CountryEnum,
        BEN: 'BEN' as CountryEnum,
        BLM: 'BLM' as CountryEnum,
        BMU: 'BMU' as CountryEnum,
        BRN: 'BRN' as CountryEnum,
        BOL: 'BOL' as CountryEnum,
        BES: 'BES' as CountryEnum,
        BRA: 'BRA' as CountryEnum,
        BHS: 'BHS' as CountryEnum,
        BTN: 'BTN' as CountryEnum,
        BVT: 'BVT' as CountryEnum,
        BWA: 'BWA' as CountryEnum,
        BLR: 'BLR' as CountryEnum,
        BLZ: 'BLZ' as CountryEnum,
        CAN: 'CAN' as CountryEnum,
        CCK: 'CCK' as CountryEnum,
        COD: 'COD' as CountryEnum,
        CAF: 'CAF' as CountryEnum,
        COG: 'COG' as CountryEnum,
        CHE: 'CHE' as CountryEnum,
        CIV: 'CIV' as CountryEnum,
        COK: 'COK' as CountryEnum,
        CHL: 'CHL' as CountryEnum,
        CMR: 'CMR' as CountryEnum,
        CHN: 'CHN' as CountryEnum,
        COL: 'COL' as CountryEnum,
        CRI: 'CRI' as CountryEnum,
        CUB: 'CUB' as CountryEnum,
        CPV: 'CPV' as CountryEnum,
        CUW: 'CUW' as CountryEnum,
        CXR: 'CXR' as CountryEnum,
        CYP: 'CYP' as CountryEnum,
        CZE: 'CZE' as CountryEnum,
        DEU: 'DEU' as CountryEnum,
        DJI: 'DJI' as CountryEnum,
        DNK: 'DNK' as CountryEnum,
        DMA: 'DMA' as CountryEnum,
        DOM: 'DOM' as CountryEnum,
        DZA: 'DZA' as CountryEnum,
        ECU: 'ECU' as CountryEnum,
        EST: 'EST' as CountryEnum,
        EGY: 'EGY' as CountryEnum,
        ESH: 'ESH' as CountryEnum,
        ERI: 'ERI' as CountryEnum,
        ESP: 'ESP' as CountryEnum,
        ETH: 'ETH' as CountryEnum,
        FIN: 'FIN' as CountryEnum,
        FJI: 'FJI' as CountryEnum,
        FLK: 'FLK' as CountryEnum,
        FSM: 'FSM' as CountryEnum,
        FRO: 'FRO' as CountryEnum,
        FRA: 'FRA' as CountryEnum,
        GAB: 'GAB' as CountryEnum,
        GBR: 'GBR' as CountryEnum,
        GRD: 'GRD' as CountryEnum,
        GEO: 'GEO' as CountryEnum,
        GUF: 'GUF' as CountryEnum,
        GGY: 'GGY' as CountryEnum,
        GHA: 'GHA' as CountryEnum,
        GIB: 'GIB' as CountryEnum,
        GRL: 'GRL' as CountryEnum,
        GMB: 'GMB' as CountryEnum,
        GIN: 'GIN' as CountryEnum,
        GLP: 'GLP' as CountryEnum,
        GNQ: 'GNQ' as CountryEnum,
        GRC: 'GRC' as CountryEnum,
        SGS: 'SGS' as CountryEnum,
        GTM: 'GTM' as CountryEnum,
        GUM: 'GUM' as CountryEnum,
        GNB: 'GNB' as CountryEnum,
        GUY: 'GUY' as CountryEnum,
        HKG: 'HKG' as CountryEnum,
        HMD: 'HMD' as CountryEnum,
        HND: 'HND' as CountryEnum,
        HRV: 'HRV' as CountryEnum,
        HTI: 'HTI' as CountryEnum,
        HUN: 'HUN' as CountryEnum,
        IDN: 'IDN' as CountryEnum,
        IRL: 'IRL' as CountryEnum,
        ISR: 'ISR' as CountryEnum,
        IMN: 'IMN' as CountryEnum,
        IND: 'IND' as CountryEnum,
        IOT: 'IOT' as CountryEnum,
        IRQ: 'IRQ' as CountryEnum,
        IRN: 'IRN' as CountryEnum,
        ISL: 'ISL' as CountryEnum,
        ITA: 'ITA' as CountryEnum,
        JEY: 'JEY' as CountryEnum,
        JAM: 'JAM' as CountryEnum,
        JOR: 'JOR' as CountryEnum,
        JPN: 'JPN' as CountryEnum,
        KEN: 'KEN' as CountryEnum,
        KGZ: 'KGZ' as CountryEnum,
        KHM: 'KHM' as CountryEnum,
        KIR: 'KIR' as CountryEnum,
        COM: 'COM' as CountryEnum,
        KNA: 'KNA' as CountryEnum,
        PRK: 'PRK' as CountryEnum,
        KOR: 'KOR' as CountryEnum,
        KWT: 'KWT' as CountryEnum,
        CYM: 'CYM' as CountryEnum,
        KAZ: 'KAZ' as CountryEnum,
        LAO: 'LAO' as CountryEnum,
        LBN: 'LBN' as CountryEnum,
        LCA: 'LCA' as CountryEnum,
        LIE: 'LIE' as CountryEnum,
        LKA: 'LKA' as CountryEnum,
        LBR: 'LBR' as CountryEnum,
        LSO: 'LSO' as CountryEnum,
        LTU: 'LTU' as CountryEnum,
        LUX: 'LUX' as CountryEnum,
        LVA: 'LVA' as CountryEnum,
        LBY: 'LBY' as CountryEnum,
        MAR: 'MAR' as CountryEnum,
        MCO: 'MCO' as CountryEnum,
        MDA: 'MDA' as CountryEnum,
        MNE: 'MNE' as CountryEnum,
        MAF: 'MAF' as CountryEnum,
        MDG: 'MDG' as CountryEnum,
        MHL: 'MHL' as CountryEnum,
        MKD: 'MKD' as CountryEnum,
        MLI: 'MLI' as CountryEnum,
        MMR: 'MMR' as CountryEnum,
        MNG: 'MNG' as CountryEnum,
        MAC: 'MAC' as CountryEnum,
        MNP: 'MNP' as CountryEnum,
        MTQ: 'MTQ' as CountryEnum,
        MRT: 'MRT' as CountryEnum,
        MSR: 'MSR' as CountryEnum,
        MLT: 'MLT' as CountryEnum,
        MUS: 'MUS' as CountryEnum,
        MDV: 'MDV' as CountryEnum,
        MWI: 'MWI' as CountryEnum,
        MEX: 'MEX' as CountryEnum,
        MYS: 'MYS' as CountryEnum,
        MOZ: 'MOZ' as CountryEnum,
        NAM: 'NAM' as CountryEnum,
        NCL: 'NCL' as CountryEnum,
        NER: 'NER' as CountryEnum,
        NFK: 'NFK' as CountryEnum,
        NGA: 'NGA' as CountryEnum,
        NIC: 'NIC' as CountryEnum,
        NLD: 'NLD' as CountryEnum,
        NOR: 'NOR' as CountryEnum,
        NPL: 'NPL' as CountryEnum,
        NRU: 'NRU' as CountryEnum,
        NIU: 'NIU' as CountryEnum,
        NZL: 'NZL' as CountryEnum,
        OMN: 'OMN' as CountryEnum,
        PAN: 'PAN' as CountryEnum,
        PER: 'PER' as CountryEnum,
        PYF: 'PYF' as CountryEnum,
        PNG: 'PNG' as CountryEnum,
        PHL: 'PHL' as CountryEnum,
        PAK: 'PAK' as CountryEnum,
        POL: 'POL' as CountryEnum,
        SPM: 'SPM' as CountryEnum,
        PCN: 'PCN' as CountryEnum,
        PRI: 'PRI' as CountryEnum,
        PSE: 'PSE' as CountryEnum,
        PRT: 'PRT' as CountryEnum,
        PLW: 'PLW' as CountryEnum,
        PRY: 'PRY' as CountryEnum,
        QAT: 'QAT' as CountryEnum,
        REU: 'REU' as CountryEnum,
        ROU: 'ROU' as CountryEnum,
        SRB: 'SRB' as CountryEnum,
        RUS: 'RUS' as CountryEnum,
        RWA: 'RWA' as CountryEnum,
        SAU: 'SAU' as CountryEnum,
        SLB: 'SLB' as CountryEnum,
        SYC: 'SYC' as CountryEnum,
        SDN: 'SDN' as CountryEnum,
        SWE: 'SWE' as CountryEnum,
        SGP: 'SGP' as CountryEnum,
        SHN: 'SHN' as CountryEnum,
        SVN: 'SVN' as CountryEnum,
        SJM: 'SJM' as CountryEnum,
        SVK: 'SVK' as CountryEnum,
        SLE: 'SLE' as CountryEnum,
        SMR: 'SMR' as CountryEnum,
        SEN: 'SEN' as CountryEnum,
        SOM: 'SOM' as CountryEnum,
        SUR: 'SUR' as CountryEnum,
        SSD: 'SSD' as CountryEnum,
        STP: 'STP' as CountryEnum,
        SLV: 'SLV' as CountryEnum,
        SXM: 'SXM' as CountryEnum,
        SYR: 'SYR' as CountryEnum,
        SWZ: 'SWZ' as CountryEnum,
        TCA: 'TCA' as CountryEnum,
        TCD: 'TCD' as CountryEnum,
        ATF: 'ATF' as CountryEnum,
        TGO: 'TGO' as CountryEnum,
        THA: 'THA' as CountryEnum,
        TJK: 'TJK' as CountryEnum,
        TKL: 'TKL' as CountryEnum,
        TLS: 'TLS' as CountryEnum,
        TKM: 'TKM' as CountryEnum,
        TUN: 'TUN' as CountryEnum,
        TON: 'TON' as CountryEnum,
        TUR: 'TUR' as CountryEnum,
        TTO: 'TTO' as CountryEnum,
        TUV: 'TUV' as CountryEnum,
        TWN: 'TWN' as CountryEnum,
        TZA: 'TZA' as CountryEnum,
        UKR: 'UKR' as CountryEnum,
        UGA: 'UGA' as CountryEnum,
        UMI: 'UMI' as CountryEnum,
        USA: 'USA' as CountryEnum,
        URY: 'URY' as CountryEnum,
        UZB: 'UZB' as CountryEnum,
        VAT: 'VAT' as CountryEnum,
        VCT: 'VCT' as CountryEnum,
        VEN: 'VEN' as CountryEnum,
        VGB: 'VGB' as CountryEnum,
        VIR: 'VIR' as CountryEnum,
        VNM: 'VNM' as CountryEnum,
        VUT: 'VUT' as CountryEnum,
        WLF: 'WLF' as CountryEnum,
        WSM: 'WSM' as CountryEnum,
        YEM: 'YEM' as CountryEnum,
        MYT: 'MYT' as CountryEnum,
        ZAF: 'ZAF' as CountryEnum,
        ZMB: 'ZMB' as CountryEnum,
        ZWE: 'ZWE' as CountryEnum
    };
}